import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaGlobe } from 'react-icons/fa';

const Navbar = () => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'pt', label: 'PT' },
    { code: 'en', label: 'EN' },
    { code: 'es', label: 'ES' }
  ];

  const changeLang = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <nav className="bg-white text-gray-900 sticky top-0 z-50 shadow-lg border-b border-gray-200">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://cdn.filestackcontent.com/J8SmC5PmTHWlMHfi5g4f/convert?cache=true&compress=true&quality=90&format=webp&rotate=exif&h=80&fit=max" 
              alt="Nautitours" 
              className="h-16 w-auto"
            />
          </Link>

          {/* Language Selector */}
          <div className="flex items-center space-x-2">
            <FaGlobe className="text-blue-600" />
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => changeLang(lang.code)}
                className={`px-3 py-2 rounded transition-colors ${
                  i18n.language === lang.code ? 'bg-blue-600 text-white font-bold' : 'hover:bg-gray-100 text-gray-700'
                }`}
              >
                {lang.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;